import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, ScanLine, UsersRound, Database, LogOut, MapPinned, Route, BarChart3 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BottomNav() {
  const location = useLocation();
  const { switchStaff, session, isAdmin, isVendedor, isCobrador } = useAuth();
  if (location.pathname === "/login" || location.pathname === "/staff-login" || !session) return null;

  // Painel: admin sempre; vendedor sem admin NÃO; cobrador sem admin SIM
  const vendedorOnly = isVendedor && !isAdmin && !isCobrador;
  const showPainel = isAdmin || isCobrador; // vendedor puro não tem painel
  const showEscanear = isAdmin || isVendedor; // cobrador puro sem escaneio
  const showAdmin = isAdmin;
  const showMinhaRota = isCobrador; // cobrador (puro ou com admin) tem Minha Rota

  const items = [
    { to: "/", icon: LayoutDashboard, label: "Painel", testid: "nav-dashboard", end: true, show: showPainel },
    { to: "/minha-rota", icon: Route, label: "Minha Rota", testid: "nav-minha-rota", show: showMinhaRota },
    { to: "/clientes", icon: Users, label: "Clientes", testid: "nav-clientes", show: true },
    { to: "/scan", icon: ScanLine, label: "Escanear", testid: "nav-scan", show: showEscanear },
    { to: "/rotas", icon: MapPinned, label: "Rotas", testid: "nav-rotas", show: showAdmin },
    { to: "/relatorios", icon: BarChart3, label: "Relatórios", testid: "nav-relatorios", show: showAdmin },
    { to: "/equipe", icon: UsersRound, label: "Equipe", testid: "nav-equipe", show: showAdmin },
    { to: "/dados", icon: Database, label: "Dados", testid: "nav-dados", show: showAdmin },
  ].filter((i) => i.show);

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-200 bg-white/95 backdrop-blur"
    >
      <div className="mx-auto max-w-3xl">
        <div
          className="flex items-center gap-1 overflow-x-auto no-scrollbar px-2 snap-x snap-mandatory sm:justify-around sm:gap-0 sm:overflow-visible"
          data-testid="bottom-nav-scroll"
        >
          {items.map(({ to, icon: Icon, label, testid, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `shrink-0 snap-start flex flex-col items-center gap-0.5 py-2.5 px-3 min-w-[64px] rounded-lg transition-colors ${
                  isActive ? "text-[color:var(--terracotta)]" : "text-stone-500 hover:text-stone-800"
                }`
              }
            >
              <Icon className="w-5 h-5" strokeWidth={2.2} />
              <span className="text-[10px] font-semibold whitespace-nowrap">{label}</span>
            </NavLink>
          ))}
          <button
            data-testid="nav-switch-staff"
            onClick={switchStaff}
            title={session?.staff?.name}
            className="shrink-0 snap-start flex flex-col items-center gap-0.5 py-2.5 px-3 min-w-[64px] rounded-lg text-stone-500 hover:text-stone-800"
          >
            <LogOut className="w-5 h-5" strokeWidth={2.2} />
            <span className="text-[10px] font-semibold whitespace-nowrap">Trocar</span>
          </button>
        </div>
        {/* Fade indicator — mostra que há mais conteúdo pra deslizar */}
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-white/95 to-transparent sm:hidden" aria-hidden="true"></div>
      </div>
    </nav>
  );
}
